import anime from "animejs";
import u from "jquery";
import { Routing } from './routing';

require("jquery.easing");

const activated = new Set(['intro']);

export const animateBulb = container => {
  anime({
    targets: `${container} .logo-bulb .main`,
    strokeDashoffset: [300, 200],
    easing: 'easeInOutSine',
    duration: 3000,
    delay: function (el, i) {
      return i * 50
    },
  });

  anime({
    targets: `${container} .logo-bulb .radius`,
    strokeDashoffset: [300, 200],
    easing: 'easeInOutSine',
    duration: 3000,
    delay: function (el, i) {
      return 1000 + (i * 300);
    },
  });
};

const animateReveal = section => {
  const reveals = u(section).find('.reveal-animation');
  let index = 1;
  reveals.each((i, el) => {
    u(el).html('<span class="bg"></span><span class="reveal-content">' + u(el).html() + '</span>').addClass('animated');
    const content = u('.reveal-content', el)[0];
    const bg = u('.bg', el)[0];

    const delay = 200 * index;
    index++;

    const timeline = anime.timeline();
    timeline.add({
      targets: bg,
      translateX: ['-101%', 0],
      easing: 'easeOutExpo',
      delay
    }).add({
      targets: content,
      opacity: 1,
      easing: 'linear',
      duration: 5,
    }).add({
      targets: bg,
      translateX: '101%',
      easing: 'easeOutExpo',
    });
  });
};

const animateBgText = name => {
  anime({
    targets: `${name} .bg-text`,
    opacity: 0.3,
    translateY: [-40, 0],
    delay: 800,
  })
}

const getSection = () => {
  const el = u(document.elementFromPoint(0, parseInt(window.innerHeight * 0.6)));
  if (el.is('section')) {
    return el.attr('id');
  } else {
    return el.parents('section').attr('id');
  }
}

const checkAnimations = (scroll_position = 0) => {
  const section = getSection();


  if (section) {
    const id = `#${section}`;
    if (!activated.has(section) && animate[section]) {
      animate[section](id);
      activated.add(section);
    }
    Routing.replaceById(id);
  }
};

export const animate = {};
animate.intro = () => {
  if (u('#intro').length === 0) {
    return;
  }

  animateReveal('#intro');
  anime.timeline().add({
    targets: '.logo',
    translateY: ['-300%', 0],
    easing: 'easeOutExpo',
    offset: 300
  }).add({
    targets: '.hamburger',
    easing: 'easeOutExpo',
    translateX: ['300%', 0],
    offset: '-=600'
  }).add({
    targets: '#effect_list button',
    easing: 'easeOutExpo',
    translateY: ['500%', 0],
    offset: '-=500',
    delay: function (el, i, l) {
      return (i * 200);
    }
  }).add({
    targets: '.social a',
    easing: 'easeOutExpo',
    translateY: ['500%', 0],
    offset: '-=300',
    delay: function (el, i, l) {
      return (i * 200);
    }
  });
};
animate.offer = () => {

  const name = '#offer';

  animateReveal(name);
  animateBgText(name);
  anime.timeline().add({
    targets: `${name} .extra-line`,
    easing: 'easeOutExpo',
    height: [0, 90],
    opacity: [0, 1],
    duration: 1000,
    delay: 400
  }).add({
    targets: `${name} .text-1`,
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1500,
    offset: '-=1000',
  }).add({
    targets: `${name} .text-2`,
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1500,
    offset: '-=1000',
  }).add({
    targets: `${name} .grid .element`,
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [30, 0],
    duration: 1500,
    offset: '-=1000',
    delay: function (el, i, l) {
      return (i * 200);
    }
  });
};
animate.portfolio = section => {
  animateReveal('#portfolio');
  animateBgText('#portfolio');
  anime.timeline().add({
    targets: '#portfolio .extra-line',
    easing: 'easeOutExpo',
    height: [0, 90],
    opacity: [0, 1],
    duration: 1000,
    delay: 400
  }).add({
    targets: '#portfolio .text-1',
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1500,
    offset: '-=1000',
  }).add({
    targets: '#portfolio .navigation li',
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1500,
    offset: '-=1000',
    delay: function (el, i, l) {
      return (i * 200);
    }
  }).add({
    targets: '#portfolio .grid .element',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [30, 0],
    duration: 1500,
    offset: '-=1900',
    delay: function (el, i, l) {
      return (i * 200);
    }
  })
};
animate.about = section => {
  animateReveal('#about');
  animateBgText('#about');
  anime.timeline().add({
    targets: '#about .extra-line',
    easing: 'easeOutExpo',
    width: [0, 90],
    opacity: [0, 1],
    duration: 1000,
    delay: 400
  }).add({
    targets: '#about .text-1',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [15, 0],
    duration: 1500,
    offset: '-=500',
  }).add({
    targets: '#about .text-2',
    easing: 'easeOutExpo',
    translateY: [15, 0],
    opacity: [0, 1],
    duration: 1500,
    offset: '-=1200',
    delay: function (el, i, l) {
      return (i * 200);
    }
  }).add({
    targets: '#about .grid .element',
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1500,
    offset: '-=1000',
    delay: function (el, i, l) {
      return (i * 200);
    }
  })
};
animate.trusted = section => {
  animateReveal('#trusted');
  animateBgText('#trusted');
  anime.timeline().add({
    targets: '#trusted .extra-line',
    easing: 'easeOutExpo',
    height: [0, 90],
    opacity: [0, 1],
    duration: 1000,
    delay: 400
  }).add({
    targets: '#trusted .text-1',
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1000,
  }).add({
    targets: '#trusted .grid .element',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [80, 0],
    duration: 1000,
    offset: '-=600',
    delay: function (el, i, l) {
      return (i * 80);
    }
  })
};
animate.contact = section => {
  animateReveal('#contact');
  animateBgText('#contact');
  animateBulb('footer');

  anime({
    targets: `footer .mouse .main`,
    strokeDashoffset: [3500, 3000],
    easing: 'easeInOutSine',
    duration: 3000,
    delay: function (el, i) {
      if (i > 1) {
        return 500;
      }
      return i * 2000;
    },
  });

  anime({
    targets: `footer .mouse .number`,
    strokeDashoffset: [3500, 3400],
    easing: 'easeInOutSine',
    duration: 3000,
    stroke: ['#fff', '#00fdc7'],
    delay: function (el, i) {
      return 1000 + (i * 300);
    },
  });

  anime.timeline().add({
    targets: 'footer .line',
    easing: 'easeOutExpo',
    height: 145,
    duration: 1000,
    delay: 400
  }).add({
    targets: 'footer .drop',
    easing: 'easeOutExpo',
    width: 12,
    height: 12,
    duration: 1000,
  });

  anime.timeline().add({
    targets: '#contact .extra-line',
    easing: 'easeOutExpo',
    height: [0, 90],
    opacity: [0, 1],
    duration: 1000,
    delay: 400
  }).add({
    targets: '#contact .text-1',
    easing: 'easeOutExpo',
    translateY: [30, 0],
    opacity: [0, 1],
    duration: 1000,
  }).add({
    targets: 'footer .grid .element',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [30, 0],
    duration: 1500,
    offset: '-=1000',
    delay: function (el, i, l) {
      return (i * 80);
    }
  }).add({
    targets: 'footer .social a',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [15, 0],
    duration: 1000,
    offset: '-=600',
    delay: function (el, i, l) {
      return (i * 80);
    }
  }).add({
    targets: 'footer hr',
    easing: 'easeOutExpo',
    width: [0, '100%'],
    duration: 1000,
    offset: '-=600',
    delay: function (el, i, l) {
      return (i * 80);
    }
  }).add({
    targets: 'footer .copyright',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [15, 0],
    duration: 600,
    offset: '-=300',
  }).add({
    targets: 'footer .links',
    easing: 'easeOutExpo',
    opacity: [0, 1],
    translateY: [15, 0],
    duration: 600,
    offset: '-=500',
  })
};
animate.init = () => {
  anime({
    targets: '.loader',
    translateY: '-100%',
    duration: 1500,
    easing: "easeOutExpo",
  });
  u('#app').on('scroll', (e) => {
    checkAnimations(e.target.scrollTop);
  });
  animate.intro();
};

checkAnimations();
